import 'common/index';
import '../product-reviews/product-reviews-page.scss';
import galleryService from 'common/util/galleryService';

galleryService.onListOpen('.review__image', '.review__images', '.review__image-image', 'data-zoom');